var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcAguardandoCartao = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:none;stroke:#2ABA83;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#2ABA83;}\r\n\t.st2{fill:#D4145A;}\r\n\t.st3{fill:#363636;}\r\n\t.st4{display:none;}\r\n\t.st5{display:inline;}\r\n\t.st6{fill:#30323A;}\r\n\t.st7{font-family:'Poppins-Regular';}\r\n\t.st8{font-size:3.9346px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bolsas_e_Olheiras"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Hidratante"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Repelente"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guias"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Barba"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Calv\\xEDcie"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Clareador"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Beleza"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Iluminador"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Preechedor"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Crescimento_Capilar"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Pesco\\xE7o_e_Colo"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Cabelo"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Sa\\xFAde"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Fortalecedor_de_Unha"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Protetor_Solar"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Texto"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.29,17.84c-2.73,0-4.95,2.22-4.95,4.95s2.22,4.95,4.95,4.95s4.95-2.22,4.95-4.95S49.02,17.84,46.29,17.84z  M46.29,26.75c-2.18,0-3.95-1.77-3.95-3.95s1.77-3.95,3.95-3.95s3.95,1.77,3.95,3.95S48.47,26.75,46.29,26.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.92,20.56l-1.58,1.58l-1.12-1.12c-0.2-0.2-0.51-0.2-0.71,0s-0.2,0.51,0,0.71l1.48,1.48 c0.09,0.09,0.22,0.15,0.35,0.15s0.26-0.05,0.35-0.15l1.93-1.93c0.2-0.2,0.2-0.51,0-0.71S48.12,20.37,47.92,20.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.29,28.65c-0.28,0-0.5,0.22-0.5,0.5v0.7H17.2v-2.6h23.97c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5H17.25 c0.25-1.66,1.67-2.95,3.41-2.95h19.22c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5H20.66c-2.45,0-4.45,1.99-4.46,4.44 c0,0,0,0,0,0.01c0,0,0,0,0,0c0,0,0,0,0,0v13.39c0,2.46,2,4.46,4.46,4.46h21.67c2.46,0,4.46-2,4.46-4.46V29.15 C46.79,28.87,46.56,28.65,46.29,28.65z M42.33,43.6H20.66c-1.91,0-3.46-1.55-3.46-3.46v-9.29h28.59v9.29 C45.79,42.05,44.24,43.6,42.33,43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.31,35.07h-2.6c-1.08,0-1.96,0.88-1.96,1.96v2.6c0,1.08,0.88,1.96,1.96,1.96h2.6c1.08,0,1.96-0.88,1.96-1.96v-2.6 C43.27,35.95,42.39,35.07,41.31,35.07z M42.27,39.63c0,0.53-0.43,0.96-0.96,0.96h-2.6c-0.53,0-0.96-0.43-0.96-0.96v-2.6 c0-0.53,0.43-0.96,0.96-0.96h2.6c0.53,0,0.96,0.43,0.96,0.96V39.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.93,36.29h-8.72c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h8.72c0.28,0,0.5-0.22,0.5-0.5S29.21,36.29,28.93,36.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.93,39.39h-8.72c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h8.72c0.28,0,0.5-0.22,0.5-0.5S29.21,39.39,28.93,39.39z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "label",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 9.7535 58.6176)",
    className: "st6 st7 st8"
  }, "AGUARDANDO CART\xC3O"))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcAguardandoCartao, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-aguardando-cartao.d0b1e0c8.svg";
export { ForwardRef as ReactComponent };